import './Banner.css'
import banner1 from './img/banner1.jpg'
import banner2 from './img/banner2.jpg'
import banner3 from './img/banner3.jpg'
import banner4 from './img/banner4.jpg'
import { Carousel } from 'react-bootstrap'

let Banner = () => {
    return(
        
        <div className="Banner">
            <Carousel className='w-100 h-100' touch='true'>
                <Carousel.Item interval={3000}>
                    <img className = "bannerImage" src={banner1}/>
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img className = "bannerImage" src={banner2}/>
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img className = "bannerImage" src={banner3}/>
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img className = "bannerImage" src={banner4}/>
                </Carousel.Item>
            </Carousel>

    </div>
        
    )
}

export default Banner;